export const selectWorkkardFields = (state) => state.workkardForm.fields;
export const selectAreFieldsLoading = (state) => state.workkardForm.fieldsLoading;
export const selectFieldsError = (state) => state.workkardForm.fieldsError;

export const selectCarriers = (state) => state.workkardForm.carriers;
export const selectAreCarriersLoading = (state) => state.workkardForm.carriersLoading;
export const selectCarriersError = (state) => state.workkardForm.carriersError;
export const selectCarriersLoaded = (state) => state.workkardForm.carriersLoaded;

export const selectIsCreatingWorkkard = (state) => state.workkardForm.createWorkkard.loading;
export const selectCreateWorkkardError = (state) => state.workkardForm.createWorkkard.error;
export const selectCreateWorkkardFieldErrors = (state) => state.workkardForm.createWorkkard.fieldErrors;
export const selectCreateWorkkardResult = (state) => state.workkardForm.createWorkkard.result;
// Set once the created claim is actually readable, which is what the redirect
// waits on -- not the POST acknowledgement.
export const selectCreatedWorkkardId = (state) => state.workkardForm.createWorkkard.readyWorkkardId;

export const selectFetchedWorkkard = (state) => state.workkardForm.fetchWorkkard.data;
export const selectIsFetchingWorkkard = (state) => state.workkardForm.fetchWorkkard.loading;
export const selectFetchWorkkardError = (state) => state.workkardForm.fetchWorkkard.error;

export const selectIsUpdatingWorkkard = (state) => state.workkardForm.updateWorkkard.loading;
export const selectUpdateWorkkardError = (state) => state.workkardForm.updateWorkkard.error;
export const selectUpdateWorkkardFieldErrors = (state) => state.workkardForm.updateWorkkard.fieldErrors;
export const selectUpdateWorkkardResult = (state) => state.workkardForm.updateWorkkard.result;
